/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Overlap_Protection_HelpInputs */



/**
* | output |
* | --- |
* | "Prevent events from overlapping in the Timeline." |
*
* @param {Options_Editor_Overlap_Protection_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_overlap_protection_help = /** @type {((inputs?: Options_Editor_Overlap_Protection_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Overlap_Protection_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Empêcher les événements de se chevaucher dans la timeline.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verhindern Sie, dass sich Ereignisse in der Zeitleiste überschneiden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impedisci la sovrapposizione degli eventi nella sequenza temporale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предотвратите наложение событий на временной шкале.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evitar que los eventos se superpongan en la línea de tiempo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("防止时间线中的事件重叠。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインでイベントが重複するのを防ぎます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन में घटनाओं को एक-दूसरे के ऊपर आने से रोकें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Impeça que os eventos se sobreponham na Linha do Tempo.")
	return /** @type {LocalizedString} */ ("Prevent events from overlapping in the Timeline.")
});